import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { StockService } from 'app/sections/stocks/services/stock.service';
import { CryptoService } from 'app/sections/crypto/services/crypto.service';
import { Subscription } from 'rxjs';
import { Ticker } from 'app/interfaces/ticker';

@Component({
  selector: 'app-ticker-status',
  templateUrl: './ticker-status.component.html',
  styleUrls: ['./ticker-status.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TickerStatusComponent implements OnInit {
  @Input('type') type : 'stock' | 'crypto';
  public loading: boolean = true;
  private shareTickerSubscription: Subscription;
  constructor(
    public stockService: StockService,
    public cryptoService: CryptoService) { 
  }

  ngOnInit(): void {
    if(this.type === 'stock'){
      /* UPDATE PERCENTAGE CHANGE */
      this.shareTickerSubscription = this.stockService.shareTicker.subscribe((ticker: Ticker) =>{
        this.loading = true;
        if(ticker){
          setTimeout(() => {
            this.loading = false;
          }, 100);
        }
      });
    } else {
      this.shareTickerSubscription = this.cryptoService.shareTicker.subscribe((ticker: Ticker)=>{
        this.loading = true;
        if(ticker){
          setTimeout(() => {
            this.loading = false;
          }, 100);
        }
      });
    }
  }

  ngOnDestroy(){
    if(this.shareTickerSubscription) this.shareTickerSubscription.unsubscribe();
  }

  get percentageClass(){
    if (this.type == 'stock') {
      let ticker = this.stockService.selectedTickerInfo.getValue();
      if(ticker){
        if(ticker?.percentageChange > 0){
          return 'text-success'
        } else {
          return 'text-danger';
        }
      }
    } else {
      let ticker = this.cryptoService.selectedTickerInfo.getValue();
      if(ticker){
        if(ticker?.percentageChange > 0){
          return 'text-success'
        } else {
          return 'text-danger';
        }
      }
    }
  }

}
